const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Global = require('app/www/components/blocks/Global/Global');
const Metrika = require('app/www/libs/client/metrika');
const Ua = require('app/www/components/blocks/Ua/Ua');

const DEFAULT_TEXT = 'Смотреть на Кинопоиске';

class Button_WatchChannelOnline extends React.PureComponent {

    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    componentDidMount() {
        const {
            exp,
            contentId,
            familyId,
            viewType,
        } = this.props;

        Metrika.trackParams('WATCH_CHANNEL', {
            type: 'show',
            familyId,
            viewType,
            exp,
            contentId: contentId,
        });
    }

    render() {
        const {
            fromBlock,
            children,
            contentId,
        } = this.props;

        const buttonProps = Object.assign({}, this.props, {
            attrs: {
                target: '_blank',
            },
            children: children || DEFAULT_TEXT,
        });

        return (
            <ButtonWrapper>
                <Button
                    url={Global.getHdChannelContentUrl(contentId, fromBlock, Ua.isMobile)}
                    ref={ref => (this.button = ref)}
                    {...buttonProps}
                    onClick={this._onClick}
                />
            </ButtonWrapper>
        );
    }

    /**
     * @private
     */
    _onClick() {
        const {
            exp,
            contentId,
            familyId,
            viewType,
        } = this.props;

        Metrika.trackParams('WATCH_CHANNEL', {
            type: 'click',
            exp,
            familyId,
            viewType,
            contentId: contentId,
        });
    }
}

Button_WatchChannelOnline.propTypes = {
    mods: Button.propTypes.mods,
    fromBlock: PropTypes.string,
    contentId: PropTypes.string,
};

module.exports = withI18n(Button_WatchChannelOnline);
